module.exports = __webpack_public_path__ + "login-form-6b98a2b5/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";